import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const commonApiSlice = createApi({
  baseQuery,
  reducerPath: 'commonApiSlice',
  endpoints: (builder) => ({
    getReasons: builder.query({
      query: () => ({
        url: '/data/reasons',
        method: 'GET',
      }),
    }),
    getConfiguration: builder.query({
      query: () => ({
        url: '/data/configuration',
        method: 'GET',
      }),
    }),
    getCounselingPrices: builder.query({
      query: (id) => {
        if (id) {
          return {
            url: `${`/counselor/update-counseling-deduction/`}${id}`,
            method: 'GET',
          };
        }
        return undefined;
      },
    }),
    getDropdown: builder.mutation({
      query: (data) => {
        if (data) {
          return {
            url: `${`/data/dropdown/v2`}`,
            method: 'POST',
            body: data
          };
        }
        return undefined;
      },
    }),
    getSessions: builder.query({
      query: () => {
        return {
          url: `${`/data/dropdown/v2`}`,
          method: 'POST',
          body: { dropdown_code: 'sessions' }
        };
      }
    }),
    getLanguage: builder.query({
      query: (data) => {
        return {
          url: `/data/dropdown`,
          method: 'POST',
          body: data
        };
      },
    }),
    getReasonsByKey: builder.query({
      query: (key) => ({
        url: `/data/reasons/${key}`,
        method: 'GET',
      }),
    }),
    getStudentFirstCallBasicDetails: builder.query({
      query: (id) => ({
        url: `/counselor/student-details/${id}`,
        method: 'GET',
      }),
    }),
    getStudentPracticeMcqList: builder.query({
      query: ({ page = 1, items = 10, filters }) => ({
        url: `/admin/users/quality-test/list?page=${page}&items=${items}`,
        method: 'POST',
        body: filters
      }),
    }),
    getStudentPlannerLink: builder.query({
      query: (id) => ({
        url: `/admin/users/student-tracker/${id}`,
        method: 'GET',
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0
    }),
    updateStudentPlannerLink: builder.mutation({
      query: ({ data }) => ({
        url: `/admin/users/student-tracker`,
        method: 'POST',
        body: data
      }),
    }),
    resetStudentPraceMcqTest: builder.mutation({
      query: (id) => ({
        url: `/admin/users/delete-test/${id}`,
        method: 'POST',
        // body: data
      }),
    }),
    refetchIsqOrder: builder.mutation({
      query: (filters) => ({
        url: `/admin/order/refetch-lsq-order`,
        method: 'POST',
        // body: data
        body: filters
      }),
    }),
    refetchOrder: builder.mutation({
      query: (id) => ({
        url: `/admin/order/refetch-order/${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetReasonsQuery,
  useGetConfigurationQuery,
  useGetCounselingPricesQuery,
  useGetDropdownMutation,
  useGetReasonsByKeyQuery,
  useGetLanguageQuery,
  useGetSessionsQuery,
  useGetStudentFirstCallBasicDetailsQuery,
  useGetStudentPracticeMcqListQuery,
  useGetStudentPlannerLinkQuery,
  useUpdateStudentPlannerLinkMutation,
  useResetStudentPraceMcqTestMutation,
  useRefetchIsqOrderMutation,
  useRefetchOrderMutation
} = commonApiSlice;
